module.exports = __webpack_public_path__ + "img/dpress.08221615.svg";